<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    :size="data.size || 'md'"
    :centered="data.centered || undefined"
    :scrollable="data.scrollable || undefined"
    :no-close-on-backdrop="data.noCloseOnBackdrop || undefined"
    :no-close-on-esc="data.noCloseOnEsc || undefined"
    :hide-header-close="data.hideHeaderClose || undefined"

    :title-html="data.title"
    :ok-title="data.okTitle || _trans('Ok')"
    :cancel-title="data.cancelTitle || _trans('Cancel')"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
    @ok="close(1)"
    @cancel="close(0)"
  >
    <template v-slot:modal-header-close>
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <p
      class="my-4"
      v-html="data.body"
    ></p>
  </b-modal>
</template>

<script>
import modal from "@dialogs/modal.vue";
export default {
    mixins: [modal]
}
</script>



// WEBPACK FOOTER //
// src/app/dialogs/modalAsk.vue